import * as React from 'react';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import styled from 'styled-components';
import { getWidth } from '@components/styles';
import { DialogConfiguration } from '@webapp/types/ui/dialog-configuration';
import Button from '../../actions/button';
import { ButtonType } from '../../actions/button/index';

export interface DialogProps extends DialogConfiguration<ButtonType> {
  className?: string;
  dialogKey: string;
}

export const Dialog: React.FC<DialogProps> = ({
  actions,
  componentProps,
  component: Component,
  title,
  callback,
  text,
  className,
  dialogKey,
}) => {
  const handleClick = (value: any) => {
    if (callback) {
      callback(value);
    }
  };
  const content =
    text && typeof text === 'string' ? (
      <Typography className="mt-10" type="small">
        {text}
      </Typography>
    ) : text ? (
      text
    ) : null;

  return (
    <Flex flexDirection="column" alignItems="center" className={className}>
      {title && <Typography weight="700">{title}</Typography>}
      {content}
      {Component && (
        <Component callback={callback} {...(componentProps || null)} />
      )}
      {actions ? (
        <Flex
          className="actions mt-30"
          justifyContent="center"
          alignItems="center"
        >
          {actions.map((action, i) => (
            <Button
              key={`dialog-${dialogKey}-button-${i}`}
              buttonType={action.type}
              onClick={() => handleClick(action.value)}
            >
              {action.label}
            </Button>
          ))}
        </Flex>
      ) : null}
    </Flex>
  );
};

export default styled(Dialog)`
  background: ${({ theme }) => theme.colors.background};
  text-align: center;
  border-radius: ${({ theme }) => theme.general.borderRadius};
  box-shadow: ${({ theme }) =>
    `${theme.general.boxShadowInput} ${theme.colors.shadow}`};
  min-width: ${getWidth(6)};
  box-sizing: border-box;
  padding: 30px 40px;

  @media ${({ theme }) => theme.device.tablet} {
    padding: 60px 80px;
    min-width: ${getWidth(8)};
  }

  .actions {
    flex-direction: column;
    width: 100%;

    @media ${({ theme }) => theme.device.tablet} {
      flex-direction: row;
      width: auto;
    }

    & > * {
      @media ${({ theme }) => theme.device.tablet} {
        max-width: 127px;
      }

      &:first-child {
        margin-bottom: 6px;

        @media ${({ theme }) => theme.device.tablet} {
          margin-bottom: 0;
          margin-right: 6px;
        }
      }
      &:nth-child(2) {
        margin-top: 6px;

        @media ${({ theme }) => theme.device.tablet} {
          margin-top: 0;
          margin-left: 6px;
        }
      }
      &:last-child {
        margin-bottom: 0;

        @media ${({ theme }) => theme.device.tablet} {
          margin-right: 0;
        }
      }
    }
  }
`;
